export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/arrayToObject.js
// module id = 512
// module chunks = 30 31 32 33 34